var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"trades"}},[(_vm.page)?_c('rich-text',{attrs:{"elements":_vm.page.document.content,"is-root":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }